import { getColorwayName } from 'utils/formatters';
import { cn } from 'utils/styles';
import CardContent from '../CardContent';
import CardWrapper from '../CardWrapper';
import { CardStyle, ImageVariantClassNames, ImageVariantProps } from '../types';
import Media from '@/components/shared/Media/Media';
import { ImageWidth } from '@/types/constants';

const ImageVariant = ({
  sys,
  index,
  total,
  color,
  cardStyle,
  showFiveStarEyebrow,
  showChimeLogo,
  eyebrow,
  headline,
  copy,
  desktopMedia,
  mobileMedia,
  desktopAspectRatio,
  mobileAspectRatio,
  imageSize = ImageWidth.Contained,
  className,
}: ImageVariantProps) => {
  const internalClassNames: ImageVariantClassNames = {
    cardWrapper: {
      wrapper: cn(
        { 'pb-6': desktopMedia == null },
        { 'flex flex-col gap-6': cardStyle !== CardStyle.None },
        className?.cardWrapper?.wrapper,
      ),
      header: cn(className?.cardWrapper?.header),
      content: cn('h-full grow-1 flex flex-col gap-6 justify-between', className?.cardWrapper?.content),
    },

    cardContent: {
      wrapper: cn('flex-0 grow-2 shrink-0', className?.cardContent?.wrapper),
      header: {
        wrapper: cn(className?.cardContent?.header?.wrapper),
        eyebrow: cn(className?.cardContent?.header?.eyebrow),
        headline: cn(className?.cardContent?.header?.headline),
      },
      copy: cn(className?.cardContent?.copy),
    },

    media: {
      wrapper: cn(
        'overflow-hidden grow-0',
        { 'px-6 pb-6 sm:px-12 sm:pb-12': imageSize === ImageWidth.Contained },
        { 'rounded-b-lg overflow-hidden': imageSize === ImageWidth.FullWidth },
        className?.media?.wrapper,
      ),
      content: cn('rounded-none', { 'w-full': imageSize === ImageWidth.FullWidth }, className?.media?.content),
    },
  };

  const testFixture = 'card-image';

  return (
    <CardWrapper
      cardStyle={cardStyle}
      index={index}
      total={total}
      color={getColorwayName(color)}
      className={internalClassNames.cardWrapper}
      testId={testFixture}>
      <CardContent
        sys={sys}
        showFiveStarEyebrow={showFiveStarEyebrow}
        showChimeLogo={showChimeLogo}
        eyebrow={eyebrow}
        headline={headline}
        copy={copy}
        testId={testFixture}
        className={internalClassNames.cardContent}
      />
      {desktopMedia ? (
        <div className={internalClassNames.media.wrapper}>
          <Media
            className={internalClassNames.media.content}
            media={desktopMedia}
            mobileMedia={mobileMedia}
            aspectRatio={desktopAspectRatio}
            mobileAspectRatio={mobileAspectRatio}
            data-testid={`${testFixture}-media-${imageSize.toLowerCase().replaceAll(' ', '-')}`}
            sizes="(max-width: 375px) 100vw, 425px"
          />
        </div>
      ) : null}
    </CardWrapper>
  );
};

export default ImageVariant;
